import {  useRef,useState,useMemo,useEffect } from 'react';
import { Card, Col,Row, Form, Input, Button, Select } from 'antd';
import { headerStyle,rowStyle  } from 'shared/styles/baseStyle';
import { useHistory, useLocation } from "react-router-dom";
import  {getHeartbeatColumns}  from 'shared/utils/getPermissionColumns';
import Validations from 'shared/validations/Validations.json';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import Report from './Report';

export default function SearchHeartbeat(){
    const [endPoint, setEndPoint] = useState()
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const myRef = useRef();
    const history = useHistory();
    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 12
        },
    };
    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });

    useEffect(() => {
        form.setFieldsValue({
            'policyNumber': queryParams.get('policyNumber'),
            'DeviceImei': queryParams.get('DeviceImei'),
            'isAlive': queryParams.get('isAlive'),
        })
        setEndPoint(`${EndPoints.REPORTS.GETHEARTBEAT}?${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish = (fieldsValues) => {
        const values = {...fieldsValues}
        Object.keys(values).forEach(key => !values[key] && delete values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.REPORTS.GETHEARTBEAT}?${params}`);
        executeScroll();
    };
    const heartbeatColumns = [
    {
        title: 'Κατάσταση Εφαρμογής',
        key: 'isAlive',
        dataIndex: 'isAlive',
        render: (isAlive)=>isAlive ? 'Ενεργή': "Ανενεργή",
    },
    {
        title: 'Ημ/νία Τελευταίας Ενεργής Κατάστασης',
        key: 'lastAliveHeartBeat',
        dataIndex: 'lastAliveHeartBeat'
    },
    ];
    const nestedColumns = [...getHeartbeatColumns(),...heartbeatColumns]
    return (
        <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
            <Row style={rowStyle}>
                <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
            </Row>
            <Form
                {...formItemLayout}
                form={form}
                onFinish={onFinish}
            >
            <Row>
                <Col span={12} >
                    <Form.Item
                        label="Policy Number:"
                        name="policyNumber"
                        rules={[{ pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12} >
                    <Form.Item
                        label="Device Imei:"
                        name="DeviceImei"
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12} >
                    <Form.Item
                        label="isAlive:"
                        name="isAlive"
                    >
                        <Select
                        style={{ width: 120 }}
                        options={[{ value: 'false', label: 'false' },{ value: 'true', label: 'all' },]}
                        />
                    </Form.Item>
                </Col>
                <Col span={8} offset={10} >
                    <Form.Item>
                        <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                            Αναζήτηση
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            </Form>    
            <Col ref={myRef}>
                <Report endPoint={endPoint} nestedColumns ={nestedColumns} source="heartbeat"/>
            </Col>
        </Card> 
    );
}